export default __webpack_public_path__ + "static/media/apple-wallet-button.c467f320.svg";